import cn from 'classnames';

import Button from 'components/form/Button.component';
import { useAppointmentPermissions } from 'hooks/useAppointmentPermissions.hook';
import { useTimeOffPermissions } from 'hooks/useTimeOffPermissions.hook';
import { canShowCreateActionInColumn } from 'utils/predicates/scheduler/canShowCreateActionInColumn.util';

import BookApptGatedByPermissions from 'scheduler/components/common/BookApptGatedByPermissions.component';
import { BookTimeOffGatedByPermissions } from 'scheduler/components/common/BookTimeOffGatedByPermissions.component';

const USE_OLD_BOOK_TIME_OFF = false;

export const MiniModalActions = ({ columnStylistId, onClose, onCreateTimeoff, onCreateNewTimeoff, onCreateBooking, t }) => {
  const appointmentPerms = useAppointmentPermissions();
  const timeOffPerms = useTimeOffPermissions();

  const showAppointment = canShowCreateActionInColumn({ columnStylistId, ...appointmentPerms });
  const showTimeOff = canShowCreateActionInColumn({ columnStylistId, ...timeOffPerms });
  const isSingleAction = showAppointment !== showTimeOff;
  const isTimeoffOnly = showTimeOff && !showAppointment;

  return (
    <div
      data-bem="MiniModal"
      data-testid="MiniModalActions"
      className={cn('mini-modal', 'full-width', {
        'mini-modal--single-action': isSingleAction,
        'mini-modal--timeoff-only': isTimeoffOnly,
      })}
    >
      <Button tag="MiniModal__close" variant="empty" className="close" onClick={onClose} aria-label={t('common.buttons.close')} />
      {USE_OLD_BOOK_TIME_OFF && (
        <BookTimeOffGatedByPermissions
          columnStylistId={columnStylistId}
          dataBem="MiniModal__old-time-off"
          className="btn-time-off"
          onClick={onCreateTimeoff}
          label={t('scheduler.newEntryModal.newTimeOffButton')}
        />
      )}

      <BookTimeOffGatedByPermissions
        columnStylistId={columnStylistId}
        dataBem="MiniModal__new-time-off"
        className="btn-time-off"
        onClick={onCreateNewTimeoff}
        label={t('scheduler.newEntryModal.newTimeOffButton')}
      />

      <BookApptGatedByPermissions
        columnStylistId={columnStylistId}
        dataBem="MiniModal__appointment"
        className="btn-book"
        onClick={onCreateBooking}
        label={t('scheduler.newEntryModal.newAppointmentButton')}
      />
    </div>
  );
};
